<template>
  <span class="d-flex align-items-start">
    <div class="d-lg-none col-5">
      <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
    </div>
    <div class="col-7 col-lg-12 font-size d-flex align-items-center gap-2">
      <span>{{ row[column.index ? column.index : column.name] }}</span>
      <span
        v-if="supplementRequestActive && supplementRequestReason"
        v-tooltip="{ title: supplementRequestReason }"
        class="dot bg-warning"
        tabindex="0"
        role="img"
        :aria-label="supplementRequestReason"
      ></span>
    </div>
  </span>
</template>

<script>
import SortTableMobileFirstColumnComponent from "@/components/table/sortTable/SortTableMobileFirstColumnComponent.vue";

export default {
  name: "SortTableRegistrationStepCellComponent",
  components: { SortTableMobileFirstColumnComponent },
  props: {
    nbColumns: {
      type: Number,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    row: {
      type: Array,
      required: true,
    },
    supplementRequestActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    supplementRequestReason: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>
